const environments = {
	dev: {
		apiBaseUrl: 'https://mpdev.devbh.in/marketplace/api/',
		blobBaseUrl: 'https://dev-qa-bighaat-media-cdn.azureedge.net/',
		irnGenerationApiBaseUrl: 'https://ml-webapi.devbh.in/',
		invoiceGenerationApiBaseUrl: 'https://ml-webapi-templates.devbh.in/',
		blobUrl: 'https://bighaatdevnewblob.blob.core.windows.net/',
	},
	qa: {
		apiBaseUrl: 'https://mp.qabh.in/marketplace/api/',
		blobBaseUrl: 'https://dev-qa-bighaat-media-cdn.azureedge.net/',
		irnGenerationApiBaseUrl: 'https://ml-webapi.qabh.com/',
		invoiceGenerationApiBaseUrl: 'https://ml-webapi-templates.qabh.in/',
		blobUrl: 'https://bighaatdevnewblob.blob.core.windows.net/',
	},
	beta: {
		apiBaseUrl: 'https://mp.betabh.in/marketplace/api/',
		blobBaseUrl: 'https://dev-qa-bighaat-media-cdn.azureedge.net/',
		irnGenerationApiBaseUrl: 'https://ml-webapi.betabh.in/',
		invoiceGenerationApiBaseUrl: 'https://ml-webapi-templates.betabh.in/',
		blobUrl: 'https://bighaatdevnewblob.blob.core.windows.net/',
	},
	prod: {
		apiBaseUrl: 'https://api.bighaat.com/marketplace/api/',
		blobBaseUrl: 'https://bighaat-prodv2-media-cdn.azureedge.net/',
		irnGenerationApiBaseUrl: 'https://ml-webapi.bighaat.com/',
		invoiceGenerationApiBaseUrl: 'https://templates.bighaat.com/',
		blobUrl: 'https://bighaat-prodv2-media-cdn.azureedge.net/',
	},
	localhost: {
		apiBaseUrl: 'https://localhost:55739/marketplace/api/',
		blobBaseUrl: 'https://dev-qa-bighaat-media-cdn.azureedge.net/',
		irnGenerationApiBaseUrl: 'https://ml-webapi.devbh.in/',
		invoiceGenerationApiBaseUrl: 'https://ml-webapi-templates.devbh.in/',
		blobUrl: 'https://bighaatdevnewblob.blob.core.windows.net/',
	},
};

export const env = 'prod';

export const {
	apiBaseUrl,
	blobBaseUrl,
	pointingEnv = env,
	irnGenerationApiBaseUrl,
	invoiceGenerationApiBaseUrl,
	blobUrl,
} = environments[env];
